<template>
    <div class="contaier">
        <div v-if="navbarBack" class="nav-back" @click="goback"></div>
        <div class="nav-title"></div>
        <div class="loan-butn" @click="loanButn"></div>
        <div class="growth">
            <div
                class="growth-item"
                v-for="(item, index) in newCardData"
                :key="index"
                @click="benefitClick(item)"
            >
                <div class="item-icon" :style="{ backgroundImage: `url(${item.icon})` }"></div>
                <div class="item-title">{{ item.title }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['newCardData', 'navbarBack'],
    watch: {
        newCardData: {
            deep: true,
            immediate: true,
            handler: function(n, o) {
                if (n) {
                    n.forEach(item => {
                        this.POINT('h5_element_imp', {
                            page: 'super-成长权益页',
                            tgt_event_id: 'h5_ACT_privilege_grade',
                            tgt_name: 'h5-ACT-成长权益-等级权益',
                            param: -1,
                            param1: '未激活',
                            param2: item.title,
                            param5: '-1',
                            param7: this.$route.query.source,
                            param8: '否'
                        });
                    });
                }
            }
        }
    },
    methods: {
        benefitClick(item) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-等级权益',
                tgt_event_id: 'h5_ACT_privilege_grade',
                param: -1,
                param1: '未激活',
                param2: item.title,
                param5: '-1',
                param7: this.$route.query.source,
                param8: '否'
            });
            this.$emit('OnBenefitClick', item);
        },
        loanButn() {
            this.$emit('OnLoanButnClick');
        },
        goback() {
            this.$emit('OnGoBack');
        }
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
.contaier {
    width: 100%;
    height: 503px;
    background-image: url('@{asserts}/newgrowth-cardbg@2x.png');
    background-size: 100% 100%;
    padding-top: 50px;
    .nav-back {
        position: absolute;
        margin-left: 18px;
        margin-top: -4px;
        width: 24px;
        height: 24px;
        background-size: 100% 100%;
        background-image: url('@{asserts}/goback-icon@2x.png');
    }
    .nav-title {
        margin: 0 142px;
        width: 90px;
        height: 22px;
        background-image: url('@{asserts}/home-title@2x.png');
        background-size: 100% 100%;
    }
    .loan-butn {
        margin: 100px 65px 0;
        width: 245px;
        height: 59px;
        background-size: 100% 100%;
        background-image: url('@{asserts}/loan-butn@2x.png');
    }
    .growth {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        padding: 44px 21px 0;
        .growth-item {
            width: 60px;
            height: 76px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 11px;
            .item-icon {
                width: 38px;
                height: 38px;
                background-size: 100% 100%;
            }
            .item-title {
                margin-top: 7px;
                color: #855749;
                font-size: 12px;
                // font-family: fzlt;
            }
        }
    }
}
</style>
